"use client";

// Last-resort error UI. Renders when the root layout itself throws —
// in that case Next can't use the regular error.tsx boundary because
// the layout it depends on is broken. global-error.tsx supplies its
// own <html> + <body> for that reason.

import { useEffect } from "react";
import posthog from "posthog-js";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    try {
      if (typeof posthog.captureException === "function") {
        posthog.captureException(error, {
          digest: error.digest,
          release: process.env.NEXT_PUBLIC_BUILD_ID,
          source: "global-error-boundary",
        });
      }
    } catch {
      console.error("[global-error-boundary]", error);
    }
  }, [error]);

  return (
    <html lang="en">
      <body style={{
        background: "#0b0b0c", color: "#f3f3f4",
        fontFamily: "system-ui, sans-serif",
        margin: 0, padding: "4rem 1.5rem",
        display: "flex", justifyContent: "center",
      }}>
        <div style={{ maxWidth: 480 }}>
          <h1>Something went very wrong.</h1>
          <p style={{ opacity: 0.7 }}>
            The error has been reported. Please refresh the page.
          </p>
          {error.digest ? <p style={{ opacity: 0.5, fontSize: "0.85rem" }}>Reference: <code>{error.digest}</code></p> : null}
        </div>
      </body>
    </html>
  );
}
